import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/risk-configurations',
        name: 'risk-configurations.index',
        component: () => import('./pages/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
] satisfies RouteRecordRaw[];
